import React, { useEffect, useState } from 'react';
import ReactHighCharts from 'react-highcharts';

const Sensor = (props) => {
  const [config, setConfig] = useState({ chart: { type: 'datetime' } });

  useEffect(() => {
    setConfig({
      chart: { zoomType: 'x', panning: true, panKey: 'shift', type: 'spline' },
      title: { text: props.name },
      xAxis: { type: 'datetime' },
      series: [{ name: props.name, data: props.data }],
      responsive: {
        rules: [{ condition: { maxWidth: 500 }, chartOptions: { legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' } } }],
      },
    });
  }, [props]);

  return <div><ReactHighCharts config={config} /></div>;
};

export default Sensor;



// WEBPACK FOOTER //
// src/components/appareils/Sensor.js